import { performanceReportingApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { CreateFieldRequest, FieldStatus, Field, FieldOption } from '../_types/fieldbank';

export default function useManageFields() {
  const create = async (
    data: CreateFieldRequest,
    callback?: (data: any) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${performanceReportingApiUrl()}/performance/fields/v1/fields`;
    await fetcher({
      url,
      method: 'POST',
      body: data,
    })
      .then((response) => {
        if (response.errorDetails) {
          // Pass the error response directly to onError instead of throwing
          if (onError) onError(response);
          return;
        }
        if (callback) callback(response);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const updateField = async (
    field: Field,
    changeNote?: string,
    callback?: (data: any) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${performanceReportingApiUrl()}/performance/fields/v1/fields/${field.id}`;
    // The field object now includes fieldOptions for SingleSelect fields
    // which will be sent directly to the API
    const requestBody = {
      ...field,
      ...(changeNote && { changeNote }),
    };

    await fetcher({
      url,
      method: 'PUT',
      body: requestBody,
    })
      .then((response) => {
        if (response.errorDetails) {
          if (onError) onError(response);
          return;
        }
        if (callback) callback(response);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const publish = async (
    fieldId: number,
    changeNote: string,
    callback?: (data: any) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${performanceReportingApiUrl()}/performance/fields/v1/fields/${fieldId}/publish`;
    await fetcher({
      url,
      method: 'POST',
      body: { changeNote },
    })
      .then((response) => {
        if (response.errorDetails) {
          if (onError) onError(response);
          return;
        }
        if (callback) callback(response);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const deactivate = async (
    fieldId: number,
    changeNote?: string,
    callback?: (data: any) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${performanceReportingApiUrl()}/performance/fields/v1/fields/${fieldId}/deactivate`;
    await fetcher({
      url,
      method: 'DELETE',
      body: { ...(changeNote && { changeNote }) },
    })
      .then((response) => {
        if (response.errorDetails) {
          if (onError) onError(response);
          return;
        }
        if (callback) callback(response);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  return {
    create,
    updateField,
    publish,
    deactivate,
  };
}
